export const getIsLivupper = (email = '') => {
  return !!/@livup\.com\.br$/.exec(email)
}
